export default __webpack_public_path__ + "static/media/jasser.6052de01.jpg";